module.exports = __webpack_public_path__ + "media/shared/banner-prop-856fffbe.svg";